import { Highlight } from 'react-instantsearch';

export function CardProductEntry(props) {
    
    const product = props?.hit;

    return (
        <a key={product.id} href={'/products' + product.slug}
            className="product-card bg-white p-4 lg:p-8 border hover:border-brand-blue-200 hover:text-brand-blue-500 transition-all duration-300 cursor-pointer rounded-md h-full flex flex-col"
            onClick={() => { props.sendEvent('click', product, 'Product Clicked') }}
            >

            {props.hit.img ?
                <div className="aspect-[4/3] bg-contain bg-no-repeat" style={{
                    backgroundImage: `url(${product.img})`
                  }}>
                </div>
            :
                <div className="flex items-center justify-center bg-brand-neutral-300 text-brand-neutral-400 w-full h-40 select-none rounded-md">
                    IMG
                </div>
            }

            <div>

                <h3 className="text-brand-blue-900 font-medium text-base/5 sm:text-lg xl:text-xl/6 my-4">{product.shortDescription}</h3>
                <h5 className="text-xs uppercase text-brand-blue-300 font-semibold mb-6"><Highlight attribute="title" classNames={{highlighted: 'bg-yellow-100'}} hit={product} /></h5>

                <div className="flex flex-wrap gap-4">
                    {product.styles && product.styles.length > 0 && (
                        <div className="bg-brand-blue-50 text-brand-blue-300 rounded-3xl py-1 px-3 inline-flex items-center text-xs">
                            {product.styles[0]}
                        </div>
                    )}
                    {product.function && product.function.length > 0 && (
                        <div className="bg-brand-blue-50 text-brand-blue-300 rounded-3xl py-1 px-3 inline-flex items-center text-xs">
                            {product.function[0]}
                        </div>
                    )}
                </div>

            </div>

        </a>
    )
}